import React from 'react'
import Moment from 'moment'

import withGame from '../../../data/withGame'
import withGamePlayers from '../../../data/withGamePlayers'
import chevronImage from '../../misc/svg/ic_chevron_right_white_24px.svg'
import {
  CellChevron,
  CellLink,
  CellTitle,
  CellMeta,
} from '../../styles'

const GameHistoryItem = ({game, players}) => {

  const overStatus = game.winner ? 'Game over' : 'In progress'
  const status = game.started ? overStatus : `Hasn't started`
  const numPlayers = players.length
  const createdOn = Moment(game.createdOn).calendar(null, {
    sameDay: '[Today]',
    lastDay: '[Yesterday]',
    lastWeek: '[Last] dddd',
    sameElse: 'MMMM Do YYYY'
  })

  return <CellLink to={`/game/${game.id}`}>
    <CellChevron src={chevronImage} />
    <CellTitle>{game.name}</CellTitle>
    <CellMeta>
      {createdOn}
      {' · '}
      {status}
      {' · '}
      {numPlayers} {numPlayers === 1 ? 'player' : 'players'}
      {game.winner ? ` · ${game.winner.name} won!` : null}
    </CellMeta>
  </CellLink>
}

export default withGame(withGamePlayers(GameHistoryItem))



// WEBPACK FOOTER //
// ./src/views/lobby/components/GameHistoryItem.jsx